import React, { useState, useEffect  } from "react";
import "./scrollTable.css";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  FormControl,
  Box,
  CircularProgress,
  InputLabel,
  Button,
} from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { PieChart, Pie, Cell, Legend, Tooltip,ResponsiveContainer } from "recharts";
import { IoIosPeople } from "react-icons/io";
import { PiStudentBold } from "react-icons/pi";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { BsPersonPlusFill } from "react-icons/bs";
import { BsLightningFill } from "react-icons/bs";
import { IoIosCash } from 'react-icons/io';
import { BsFillCreditCardFill } from 'react-icons/bs';
import { MdGroup } from 'react-icons/md';
import { useAuth } from "../../../AuthProvider";
import { GlobalStyles, width } from "@mui/system";

import { BarChart, Bar, CartesianGrid, XAxis, YAxis} from 'recharts';
import { useNavigate } from "react-router-dom";

import { useRef } from "react";
import { useParams } from "react-router-dom";



const baseUrl=process.env.REACT_APP_API_BASE_URL



const Dashboard = () => {
  // const [selectedDate, setSelectedDate] = useState("today");

const [tableSelectData, setTableSelectData] = useState("today");  // Default for table
const [pieSelectData, setPieSelectData] = useState("today");      // Default for pie chart
const navigate = useNavigate();

 const { prId } = useParams();
const {oId,board,pId,plan,feature}=useAuth();
const PrincipalId = pId || prId;

const [notices, setNotices] = useState([]);
const [loadingNotices, setLoadingNotices] = useState(true);
 const [searchQuery, setSearchQuery] = useState("");
const [isLoading,setIsLoading]=useState(false);

const [teachersCount, setteachersCount] = useState({});
const [studentCounts, setStudentCounts] = useState({});
const [tuitionFeeAmounts, setTuitionFeeAmounts] = useState({});
const [busFeeAmounts, setBusFeeAmounts] = useState({});
const [schoolFeeAmounts, setSchoolFeeAmounts] = useState({});
const [schoolFeeDate, setSchoolFeeDate] = useState("today");


// const [announcements, setAnnouncements] = useState([]);
const marqueeRef = useRef(null);
const [announcements, setAnnouncements] = useState({
  exams: [],
  notices: [],
  teachers: [],
  parents: []
});

const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0); // Track which category is currently showing
const [currentCategory, setCurrentCategory] = useState([]); // Announcements of the current category

const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);
const [groupedAnnouncements, setGroupedAnnouncements] = useState([]);
const [error, setError] = useState(null);
const [currentIndex, setCurrentIndex] = useState(0);

// const [selectedClass, setSelectedClass] = useState(1);
// const [selectedSection, setSelectedSection] = useState("SECTION-A");


// const [selectedClass, setSelectedClass] = useState("Class-I");
// const [selectedSection, setSelectedSection] = useState("Section-A");
// const [selectedDay, setSelectedDay] = useState("Monday");
const [loading, setLoading] = useState(true);

const [classfilteredData, setClassFilteredData] = useState([]);
const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
// const [sscSelectedClass, setSscSelectedClass] = useState("Class-I");
// const [sscSelectedSection, setSscSelectedSection] = useState("Section-A");
const [sscSelectedClass, setSscSelectedClass] = useState('');
const [sscSelectedSection, setSscSelectedSection] = useState('');

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
// const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
// const [interSelectedSection, setInterSelectedSection] = useState("Section-A");
const [interSelectedClass, setInterSelectedClass] = useState('');
const [interSelectedSection, setInterSelectedSection] = useState('');
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");

const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
// console.log("selected mode :"+mode);
const [sscClassSectionMap, setSscClassSectionMap] = useState({});




const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];



const [selectedBus, setSelectedBus] = useState("");
  const [busData, setBusData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

const [dateRange, setDateRange] = useState("currentAcademicYear");


 


  const [expenseloading, setExpenseLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]);
  const [expenseData, setExpenseData] = useState([]);


const renderCount = useRef(0);
renderCount.current += 1;
console.log("Dashboard render count:", renderCount.current, { oId, PrincipalId });


//fetch table scrolling data
const fetchTableScrollingData = async () => {
  if (!oId && !PrincipalId) return; // Exit if required params missing

  setLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/api/teacherTimeTable/getAllTeacherScrollingTimeSlots/${oId}/${PrincipalId}`
    );

    if (!response.ok) {
      console.error(`Error fetching table data: HTTP status ${response.status}`);
      setClassFilteredData([]);
      return;
    }

    const data = await response.json();

    if (Array.isArray(data)) {
      setClassFilteredData(data);
      // Optionally, update unique courses here if needed
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setClassFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching table data:", error);
    setClassFilteredData([]);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  console.log("useEffect fired with oId:", oId, "PrincipalId:", PrincipalId);

  if (oId && PrincipalId) {
    console.log("Fetching table scrolling data");
    fetchTableScrollingData();
  }
}, [oId, PrincipalId]);




// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options
      setSscClassSectionMap(classSectionMap); // Save for section filtering later

      // No default selection
      setSscSelectedClass("");
      setSscSelectedSection("");
      setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};






// ---- Fetch Table Data for SSC ----


const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection) {
    setClassFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/teacherTimeTable/getAllTeacherClassSectionWise/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setClassFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setClassFilteredData([]);
    }

  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};






// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
// Fetch Courses for INTERMEDIATE
const fetchCourseData = async () => {
    if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (data.length > 0) {
      //   setSelectedCourseType(data); // <-- triggers fetchSectionsData via useEffect
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};


// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
     
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setClassFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/teacherTimeTable/getAllTeacherClassSectionWise/${oId}/${pId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setClassFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setClassFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};

// useEffect(() => {
//   if (board === "INTERMEDIATE" && selectedCourseType && interSelectedClass) {
//     fetchSectionsData(); // Updates interSectionOptions and interSelectedSection
//   }
// }, [selectedCourseType, interSelectedClass, board]);

// useEffect(() => {
//   if (board === "SSC") {
//     fetchClassRegistrationData(); // Updates interSectionOptions and interSelectedSection
//   }
// }, [oId, board]);


// Load class data based on board and related dependencies
useEffect(() => {
  const loadClassData = async () => {
    if (!oId) return; // Exit if org ID not available

    if (board === "INTERMEDIATE") {
      if (!interSelectedClass || !selectedCourseType) return; 
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board, interSelectedClass, selectedCourseType, oId]);

// Fetch courses if board is INTERMEDIATE and interSelectedClass is valid
useEffect(() => {
  if (board === "INTERMEDIATE" && interSelectedClass && oId) {
    fetchCourseData();
  }
}, [interSelectedClass, board, oId]);

// Fetch table data based on current filters and board type
// useEffect(() => {
//   if (!board) return;

//   if (board === "SSC") {
//     if (!sscSelectedClass || !sscSelectedSection) {
//       setClassFilteredData([]);
//       setLoading(false);
//       return;
//     }
//     fetchClassSectionTableData();
//   } else if (board === "INTERMEDIATE") {
//     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
//       setClassFilteredData([]);
//       setLoading(false);
//       return;
//     }
//     fetchCourseClassSectionTableData();
//   }
// }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);



useEffect(() => {
  const fetchData = () => {
    if (board === "SSC") {
      if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
        fetchClassSectionTableData();
      } else {
        setClassFilteredData([]);
        setLoading(false);
      }
    } else if (board === "INTERMEDIATE") {
      if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
        fetchCourseClassSectionTableData();
      } else {
        setClassFilteredData([]);
        setLoading(false);
      }
    }
  };

  fetchData();
}, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);





















  const getLastThreeMonths = (selectedMonth) => {
    const monthOrder = [
      'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
      'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
    ];
   
    const index = monthOrder.indexOf(selectedMonth.toUpperCase());
    const result = [];
 
    for (let i = 2; i >= 0; i--) {
      const monthIndex = (index - i + 12) % 12;
      result.push(monthOrder[monthIndex]);
    }
 
    return result; // Will return in order: [NOVEMBER, DECEMBER, JANUARY] when selectedMonth is JANUARY
  };


const fetchExpensesBarGraphData = async () => {
  if (!oId &&  !PrincipalId) return; // Exit if required params missing

  setExpenseLoading(true);
  try {
    const response = await fetch(`${baseUrl}/api/principal/pr/last-three-months-expenses/${oId}/${PrincipalId}?selectedMonth=${selectedMonth}`);
    if (!response.ok) {
      throw new Error("Failed to fetch expenses data");
    }

    const data = await response.json();
    const months = getLastThreeMonths(selectedMonth);
    const formattedData = months
      .filter((month) => data[month] !== undefined)
      .map((month, index) => ({
        name: month,
        value: data[month],
        color: index === 0 ? "#8884d8" : index === 1 ? "#82ca9d" : "#ff7300",
      }));

    setExpenseData(formattedData);
  } catch (error) {
    console.error("Error fetching expenses data:", error);
  } finally {
    setExpenseLoading(false);
  }
};

useEffect(() => {
  fetchExpensesBarGraphData();
}, [selectedMonth, oId, PrincipalId]); // Added oId and PrincipalId to dependencies

 
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };
 





const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  padding: "5px",
  gap: "15px",
  width: "100%",
};

const cardStyle = {
  flex: 1,
  padding: "5px",
  borderRadius: "10px",
  boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.2s",
  backgroundColor: "#fff",
  borderLeft: "5px solid",
};

const titleStyle = {
  fontWeight: "bold",
  fontSize: "18px",
  marginBottom: "10px",
};

const itemStyle = (borderColor) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px",
  borderRadius: "6px",
  marginBottom: "5px",
  cursor: "pointer",
  fontSize: "14px",
  backgroundColor: "#fff", // Keep background white
  border: `2px solid ${borderColor}`, // Border color added
  transition: "background-color 0.2s ease",
  ':hover': {
    backgroundColor: "#e8f0fe"
  }
});

 const iconStyle = (bgColor) => ({
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "8px",
    padding: "3px",
  });




 const cardData = [
  {
    title: "Teachers Overview",
    color: "#007bff",
    items: [
      { label: "TOTAL TEACHERS", value: <span style={{ color: "#4B0082" }}>{`${teachersCount.total || 0}`}</span>, icon: <PiStudentBold />, path: "/TotalTeachersList", state: { PrincipalId }, bgColor: "#cce5ff" },
      { label: "PRESENT TEACHERS", value: <span style={{ color: "#28a745" }}>{`${teachersCount.present || 0}`}</span>, icon: <BsPersonPlusFill />, path: "/PresentTeachersList", state: { PrincipalId }, bgColor: "#cce5ff" },
      { label: "ABSENT TEACHERS", value: <span style={{ color: "#DC3545" }}>{`${teachersCount.absent || 0}`}</span>, icon: <MdGroup />, path: "/AbsentTeachersList", state: { PrincipalId }, bgColor: "#cce5ff" },
    ],
  },
    {
      title: "Students Overview",
      color: "#28a745",
      items: [
        { label: "TOTAL STUDENTS", value: <span style={{ color: "#4B0082" }}>{`${studentCounts.totalStudents || 0}`}</span>, icon: <PiStudentBold />, path: "/AllStudentList",state: { PrincipalId }, bgColor: "#cce5ff" },
        { label: "PRESENT STUDENTS", value: studentCounts.presentStudents || 0, icon: <BsPersonPlusFill />, path: "/PresentStudentsList",state: { PrincipalId }, bgColor: "#cce5ff" },
        { label: "ABSENT STUDENTS", value: <span style={{ color: "#DC3545" }}>{`${studentCounts.absentStudents || 0}`}</span>, icon: <MdGroup />, path: "/AbsentStudentsList",state: { PrincipalId }, bgColor: "#c8e6c9" },
      ],
    },
    {
      title: "Tuition Fee",
      color: "#4B0082",
      items: [
        { label: "Total Fee", value: `₹${tuitionFeeAmounts.tutionFeePayments || 0}`, icon: <IoIosCash />, path: "/FeesDetailsList",state: { PrincipalId }, bgColor: "#cce5ff" },
        { label: "PAID", value: <span style={{ color: "#28a745" }}>{`₹${tuitionFeeAmounts.tutionFeePaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/PaidFeesList?dateRange=${dateRange}`,state: { PrincipalId }, bgColor: "#d4edda" },
        { label: "UNPAID", value: <span style={{ color: "#DC3545" }}>{`₹${tuitionFeeAmounts.tutionFeeUnPaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/UnPaidFeesList?dateRange=${dateRange}`,state: { PrincipalId }, bgColor: "#f8d7da" },
      ],
    },
     ...((feature === "CORE" || feature === "ULTRA")? [
   
    {
      title: "Bus Fee",
      color: "#dc3545",
      items: [
        { label: "Total Fee", value:<span style={{ color: "#4B0082" }}>{ `₹${busFeeAmounts.busFeePayments || 0}`}</span>, icon: <IoIosCash />, path: "/BusFeesDetailsList",state: { PrincipalId }, bgColor: "#cce5ff" },
        { label: "PAID", value:<span style={{ color: "#28a745" }}>{ `₹${busFeeAmounts.busFeePaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/PaidBusFeeList?dateRange=${dateRange}`,state: { PrincipalId }, bgColor: "#d4edda" },
        { label: "UNPAID", value: `₹${busFeeAmounts.busFeeUnPaid || 0}`, icon: <BsFillCreditCardFill />, path: `/UnpaidBusFeeList?dateRange=${dateRange}`,state: { PrincipalId }, bgColor: "#f8d7da" },
      ],
    },

      ]: []), // Don't include 'Packages' if not ULTRA
  ];

  // Conditionally push Bus Fee section
// if (feature === "CORE" || feature === "ULTRA") {
//   cardData.push({
//     title: "Bus Fee",
//     color: "#dc3545",
//     items: [
//       {
//         label: "Total Fee",
//         value: <span style={{ color: "#4B0082" }}>{`₹${busFeeAmounts.busFeePayments || 0}`}</span>,
//         icon: <IoIosCash />,
//         path: "/BusFeesDetailsList",
//         state: { PrincipalId },
//         bgColor: "#cce5ff",
//       },
//       {
//         label: "PAID",
//         value: <span style={{ color: "#28a745" }}>{`₹${busFeeAmounts.busFeePaid || 0}`}</span>,
//         icon: <BsFillCreditCardFill />,
//         path: `/PaidBusFeeList?dateRange=${dateRange}`,
//         state: { PrincipalId },
//         bgColor: "#d4edda",
//       },
//       {
//         label: "UNPAID",
//         value: `₹${busFeeAmounts.busFeeUnPaid || 0}`,
//         icon: <BsFillCreditCardFill />,
//         path: `/UnpaidBusFeeList?dateRange=${dateRange}`,
//         state: { PrincipalId },
//         bgColor: "#f8d7da",
//       },
//     ],
//   });
// }




const renderLabel = (entry) => {
  return entry.name;
};

const [tableDate, setTableDate] = useState("today");
const [pieChartDate, setPieChartDate] = useState("today");



const pieData = [
  // { name: "Total Tuition Fee", value: tuitionFeeAmounts.tutionFeePayments  || 0, color: "#EC407A" },
  { name: "Tuition Fee Paid", value: tuitionFeeAmounts.tutionFeePaid || 0, color: "#28a745" },
  { name: "Tuition Fee Unpaid", value:tuitionFeeAmounts.tutionFeeUnPaid   || 0, color: "#DC3545" },
  // { name: "Total Bus Fee", value: busFeeAmounts.busFeePayments || 0, color: "#1976D2" },
  // { name: "Bus Fee Paid", value: busFeeAmounts.busFeePaid  || 0, color: "#7E57C2" },
  // { name: "Bus Fee Unpaid", value: busFeeAmounts.busFeeUnPaid  || 0, color: "#FF9800" }, // Added a new color for this category
];

// Check if all values are zero to show fallback data
const hasData = pieData.some((item) => item.value > 0);

// Default placeholder data when no real data is available
const defaultPieData = [{ name: "No Data Available", value: 1, color: "#d3d3d3" }];

// Use actual data if available; otherwise, use fallback data
const finalPieData = hasData ? pieData : defaultPieData;
const total = finalPieData.reduce((sum, entry) => sum + entry.value, 0);



const pieData1 = [
  // { name: "Total Tuition Fee", value: tuitionFeeAmounts.tutionFeePayments  || 0, color: "#EC407A" },
  // { name: "Tuition Fee Paid", value: tuitionFeeAmounts.tutionFeePaid || 0, color: "#303F9F" },
  // { name: "Tuition Fee Unpaid", value:tuitionFeeAmounts.tutionFeeUnPaid   || 0, color: "#26C6DA" },
  // { name: "Total Bus Fee", value: busFeeAmounts.busFeePayments || 0, color: "#1976D2" },
  { name: "Bus Fee Paid", value: busFeeAmounts.busFeePaid  || 0, color: "#28a745" },
  { name: "Bus Fee Unpaid", value: busFeeAmounts.busFeeUnPaid  || 0, color: "#DC3545" }, // Added a new color for this category
];

// Check if all values are zero to show fallback data
const hasData1 = pieData1.some((item) => item.value > 0);

// Default placeholder data when no real data is available
const defaultPieData1 = [{ name: "No Data Available", value: 1, color: "#d3d3d3" }];

// Use actual data if available; otherwise, use fallback data
const finalPieData1 = hasData1 ? pieData1 : defaultPieData1;
const total1 = finalPieData1.reduce((sum, entry) => sum + entry.value, 0);

// Filter data based on searchQuery
const filteredResults = (Array.isArray(filteredData) ? filteredData : []).filter((item) => {
  const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
  const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
  const fullName = `${studentFirstName} ${studentLastName}`.trim();

  return (
    fullName.includes(searchQuery.toLowerCase()) ||
    (item.admissionNumber && item.admissionNumber.includes(searchQuery)) // Ensure admissionNumber exists
  );
});







//select Bus API
 
      // useEffect(() => {
      //   const fetchData = async () => {
       
      //     try {
      //       const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${PrincipalId}`);
      //       if (!response.ok) throw new Error("Failed to fetch bus numbers");
     
      //       const data = await response.json();
      //       console.log("Fetched Bus Numbers:", data);
      //     setBusData(data || []);
      //       if (data.length > 0) {
      //         setSelectedBus(data[0].busNumber);
      //       }
      //     } catch (error) {
      //       console.error("Error fetching bus numbers:", error);
      //     }
      //   };
     
      //   fetchData();
      // }, [oId]);

    useEffect(() => {
  if (!PrincipalId) return; // Exit if PrincipalId not available

  const fetchData = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${PrincipalId}`);
      if (!response.ok) {
        console.error(`Failed to fetch bus numbers. HTTP status: ${response.status}`);
        setBusData([]);
        return;
      }

      const data = await response.json();
      setBusData(data || []);

      if (data.length > 0) {
        setSelectedBus(String(data[0].busNumber)); // Ensure string type
      }
    } catch (error) {
      console.error("Error fetching bus numbers:", error);
    }
  };

  fetchData();
}, [PrincipalId]);






      //List of Students Present in Bus API
   const fetchBusFeeDetails = async () => {
  if (!selectedBus || !PrincipalId || !oId) {
    setTableLoading(false); // Remove loading if no bus selected or params missing
    return;
  }

  setTableLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/api/busAttendiesDashBoard/getAllStudentsPresentListInBus/${PrincipalId}?busNumber=${selectedBus}`
    );

    if (!response.ok) throw new Error("Failed to fetch bus fee data");

    const data = await response.json();
    console.log("Bus Fee Data:", data);

    setFilteredData(data || []);
  } catch (err) {
    console.error("Error fetching bus fee transactions:", err);
    setFilteredData([]);
  } finally {
    setTableLoading(false);
  }
};

useEffect(() => {
  fetchBusFeeDetails();
}, [selectedBus, oId, PrincipalId]); // Added PrincipalId




//Notice Board API
const fetchNotices = async () => {
  if (!oId || !PrincipalId){
    setLoadingNotices(false);
     return; // Exit if params not ready
  }

  setLoadingNotices(true);
  try {
    const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${PrincipalId}`);
    if (!response.ok) {
      console.error(`Error fetching notices. HTTP status: ${response.status}`);
      setNotices([]);
      return;
    }
    const data = await response.json();
    data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));
    setNotices(data);
  } catch (error) {
    console.error("Error fetching notices:", error);
    setNotices([]);
  } finally {
    setLoadingNotices(false);
  }
};

useEffect(() => {
  fetchNotices();
}, [oId, PrincipalId]);


// Filter notices based on search query
const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    notice.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
   
  );
});


//teachers card counts state



useEffect(() => {
  if (!oId || !PrincipalId) return; // Exit if required params are missing

  const fetchData = async () => {
    try {
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

      const response = await fetch(`${baseUrl}/api/attendance/teachers/count/${formattedDate}/${oId}/${PrincipalId}`);
      
      if (!response.ok) {
        console.error(`Error fetching teacher counts. HTTP status: ${response.status}`);
        return;
      }

      const data = await response.json();
      setteachersCount(data);
    } catch (error) {
      console.error("Error fetching teacher counts: ", error);
    }
  };

  fetchData();
}, [oId, PrincipalId]);



//Students API
  useEffect(() => {
  if (!oId || !PrincipalId) return; // Prevent fetching if params missing

  const fetchStudentCounts = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/admissionDashBoard/principal/countAllStudentsAttendance/${oId}/${PrincipalId}`);

      if (!response.ok) {
        console.error(`Error fetching student data. HTTP status: ${response.status}`);
        return;
      }

      const data = await response.json();
      setStudentCounts(data);
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  fetchStudentCounts();
}, [oId, PrincipalId]); // Added PrincipalId to dependencies




  const fetchTutionFeeAmounts = async () => {
  if (!oId || !PrincipalId) return; // Exit if required params missing

  setExpenseLoading(true); // Optional loading indicator

  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (dateRange) {
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllTodayTutionPayments/${formattedDate}/tution_fee/${oId}/${PrincipalId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllYesterDayTutionPayments/${formattedDate}/tution_fee/${oId}/${PrincipalId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllLastWeekTutionPayments/${formattedDate}/tution_fee/${oId}/${PrincipalId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllThisMonthTutionPayments/${formattedDate}/tution_fee/${oId}/${PrincipalId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllLastSixMonthsTutionPayments/${formattedDate}/tution_fee/${oId}/${PrincipalId}`;
        break;
      case "currentAcademicYear":
      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllCurrentAcademicYearTutionPayments/${formattedDate}/tution_fee/${oId}/${PrincipalId}`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch tuition fee amounts");

    const data = await response.json();
    setTuitionFeeAmounts(data);

  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
  } finally {
    setExpenseLoading(false); // Optional loading state off
  }
};

useEffect(() => {
  fetchTutionFeeAmounts();
}, [dateRange, oId, PrincipalId]);



const fetchBusFeeAmounts = async () => {
  if (!oId || !PrincipalId) return; // Exit if required params missing

  setExpenseLoading(true); // Show loading indicator optionally

  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (dateRange) {
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}/${PrincipalId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllYesterdayBusPayments/${formattedDate}/bus_fee/${oId}/${PrincipalId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllLastWeekBusPayments/${formattedDate}/bus_fee/${oId}/${PrincipalId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllThisMonthBusPayments/${formattedDate}/bus_fee/${oId}/${PrincipalId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllLastSixMonthsBusPayments/${formattedDate}/bus_fee/${oId}/${PrincipalId}`;
        break;
      case "currentAcademicYear":
      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllCurrentAcademicYearBusPayments/${formattedDate}/bus_fee/${oId}/${PrincipalId}`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch bus fee amounts");

    const data = await response.json();
    setBusFeeAmounts(data);

  } catch (error) {
    console.error("Error fetching bus fee amounts:", error);
  } finally {
    setExpenseLoading(false); // Hide loading indicator
  }
};

useEffect(() => {
  fetchBusFeeAmounts();
}, [dateRange, oId, PrincipalId]);


useEffect(() => {
  if (!oId || !PrincipalId) return; // Ensure required params are present

  const fetchAnnouncements = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/Announcement/getAnnouncement/${oId}/${PrincipalId}`);
      if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

      const data = await response.json();

      const exams = data.examsAnnouncementDto?.map(
        (exam) => `📅 ${exam.examType.replace("_", " ")} Exam on ${exam.examDate} at ${exam.examTime}`
      ) || [];

      const notices = data.noticeAnnouncementsDtos?.map(
        (notice) => `📢 ${notice.title} on ${notice.purposeDate} `
      ) || [];

      const teachers = data.teacherAnnouncementDto?.map(
        (announcement) => `🎓 ${announcement.title} on ${announcement.purposeDate} `
      ) || [];

      const parents = data.parentAnnouncementDto?.map(
        (meeting) => `👨‍👩‍👧 Parent-Teacher Meeting on ${meeting.purposeDate} `
      ) || [];

      const hasAnnouncements = exams.length || notices.length || teachers.length || parents.length;
      const defaultMessage = ["📢 No announcements available"];

      setAnnouncements(
        hasAnnouncements
          ? { exams, notices, teachers, parents }
          : { exams: defaultMessage, notices: [], teachers: [], parents: [] }
      );

    } catch (error) {
      console.error("Error fetching announcements:", error);
      setAnnouncements({ exams: ["📢 No announcements available"], notices: [], teachers: [], parents: [] });
    }
  };

  fetchAnnouncements();

}, [baseUrl, oId, PrincipalId]); // Added PrincipalId to dependency array





  return (
    <div style={{ backgroundColor: "#F5F5F6", minHeight: "100vh", padding: "10px" }}>
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>

     

     
      {/* Grid for Teachers and Students Stats */}
      <Grid container spacing={1} style={{ marginTop: "5%" }}>


<div style={containerStyle}>
      {cardData.map((card, index) => (
        <div key={index} style={{ ...cardStyle, borderLeftColor: card.color }}>
         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", ...titleStyle }}>
  <div>{card.title}</div>

 
</div>


          {card.items.map((item, idx) => (
            <div
              key={idx}
              style={itemStyle(item.bgColor)} // Apply border color from bgColor
              // onClick={() => navigate(item.path)}
               onClick={() => navigate(item.path, { state: item.state })}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#e8f0fe";
                // e.currentTarget.style.transform = "scale(1.02)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#f9f9f9";
                // e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={iconStyle(item.bgColor)}>{item.icon}</div>
                <span style={{ fontWeight: "bold" }}>{item.label}</span>
              </div>
              <span style={{ fontWeight: "bold", color: card.color }}>{item.value}</span>
            </div>
          ))}
        </div>
      ))}
    </div>


</Grid>



<marquee
    ref={marqueeRef} // Attach the ref to the marquee
    behavior="scroll"
    direction="right"
    scrollamount="5"
    onMouseEnter={() => marqueeRef.current && marqueeRef.current.stop()}
    onMouseLeave={() => marqueeRef.current && marqueeRef.current.start()}
    style={{
      marginTop: "13px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "4px 0",
      width: "100%",
      whiteSpace: "nowrap",
    }}
  >
    {[
      ...announcements.exams,
      ...announcements.notices,
      ...announcements.teachers,
      ...announcements.parents,
    ].map((announcement, index) => (
      <span key={index} style={{ marginRight: "20px" }}>
        {announcement}
      </span>
    ))}
  </marquee>

{/* Present Class Data */}

      <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between" }}>
         {/* Card containing table title, date selector, and table */}
      <Paper style={{ flex: 2, padding: "5px", backgroundColor: "#FFFFFF", borderRadius: "8px", marginRight: "5px" }}>
        <div style={{ flex: 2, marginLeft: "0px", paddingLeft: "10px", paddingRight: "10px", overflow: "auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography
  variant="h5"
  style={{
    fontWeight: "bold",
    paddingLeft: "5px", // Added left padding
    marginTop: "5px",   // Added top margin
  }}
>
  Present Class Data
</Typography>


<div style={{ display: 'flex', gap: '10px', marginLeft: 'auto', marginTop: '10px', paddingBottom: '10px' }}>
  {/* Class Selection */}
  {/* <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
  <InputLabel id="class-select-label">
  {board === "INTERMEDIATE" ? "Select Year" : "Select Class"}
  </InputLabel>
  <Select
    labelId="class-select-label"
    value={selectedClass}
    onChange={handleClassChange}
    label={board === "INTERMEDIATE" ? "Select Year" : "Select Class"}
    sx={{ height: 35 }}
    // disabled={classOptions.length === 0} // Disable dropdown if no options
  >
    {classOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Register Classes to view
      </MenuItem>
    ) : (
      classOptions.map((cls) => (
        <MenuItem key={cls} value={cls}>
          {cls}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>


<FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
  <InputLabel>Select Section</InputLabel>
  <Select
    value={selectedSection}
    onChange={(e) => setSelectedSection(e.target.value)}
    label="Select Section"
    sx={{ height: 35 }}
    disabled={sectionOptions.length === 0}
  >
    {sectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Class to view Sections
      </MenuItem>
    ) : (
      sectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl> */}

<Button
  onClick={() => {
    if (board === "SSC") {
      setSscSelectedClass('');
      setSscSelectedSection('');
    } else if (board === "INTERMEDIATE") {
      setInterSelectedClass('');
      setSelectedCourseType('');
      setInterSelectedSection('');
    }

    setMode("scrolling");
    fetchTableScrollingData();
  }}
   sx={{
                                                                          backgroundColor: "#4CAF50",
                                                                          color: "white",
                                                                          // width:"110px",
                                                                          padding: "5px 10px",
                                                                          borderRadius: "5px",
                                                                          fontWeight: "bold",
                                                                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                                          "&:hover": {
                                                                            transform: "scale(1.05)",
                                                                            backgroundColor: "#4CAF50",
                                                                          },
                                                                        }}
>
  On Going
</Button>



{board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
       

        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          setMode("classSection");
     
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
       
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>
{/*
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="section-select-label">Select Section</InputLabel>
      <Select
        labelId="section-select-label"
        value={sscSelectedSection}
        // onChange={(e) => setSscSelectedSection(e.target.value)}
        onChange={(e) => {
          setSscSelectedSection(e.target.value);
          setMode("classSection");
        }}
       
        label="Select Section"
        sx={{ height: 35 }}
        // disabled={sscSectionOptions.length === 0}
      >
       
        {sscSectionOptions.map((section) => (
          <MenuItem key={section} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl> */}
    <FormControl size="small" sx={{ minWidth: 120 }}>
  <InputLabel id="section-select-label">Select Section</InputLabel>
  <Select
    labelId="section-select-label"
    value={sscSelectedSection}
    onChange={(e) => {
      setSscSelectedSection(e.target.value);
      setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {/* Show placeholder if no sections */}
    {sscSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Class
      </MenuItem>
    ) : (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
        onChange={(e) => {
          setSelectedCourseType(e.target.value);
          setMode("classSection");
        }}
       
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

    {/* <FormControl size="small" sx={{ minWidth: 120}}>
      <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
      <Select
        labelId="intermediate-section-select-label"
        value={interSelectedSection}
        // onChange={(e) => setInterSelectedSection(e.target.value)}
        onChange={(e) => {
          setInterSelectedSection(e.target.value);
          setMode("classSection");
        }}
       
        label="Select Section"
        sx={{ height: 35 }}
      >
        {interSectionOptions.map((section, index) => (
          <MenuItem key={index} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl> */}
    <FormControl size="small" sx={{ minWidth: 120 }}>
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    value={interSelectedSection || ""}
    onChange={(e) => {
      setInterSelectedSection(e.target.value);
      setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {interSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Year and Course
      </MenuItem>
    ) : (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}

</div>




          </div>
          <TableContainer
  component={Paper}
  style={{
    maxHeight: "280px",
    overflowY: "auto",
    // maxHeight: classfilteredData.length > 10 ? '280px' : 'auto',
    // overflowY: classfilteredData.length > 10 ? 'auto' : 'visible',
    marginTop: "10px",
    position: "relative",
  }}
  // onMouseEnter={(e) => {
  //   e.currentTarget.querySelector('tbody').style.animationPlayState = "paused"; // Pause the animation on mouse enter
  // }}
  // onMouseLeave={(e) => {
  //   e.currentTarget.querySelector('tbody').style.animationPlayState = "running"; // Resume the animation on mouse leave
  //           }}
>
  <Table stickyHeader>
    {/* Table Head */}
    <TableHead>
      <TableRow>
        {["S.No", "Day", board === "INTERMEDIATE" ? "Year" : "Class", ...(board === "INTERMEDIATE" ? ["Course"] : []),"Section", "Subject", "Teacher Name", "Time", "Period", "Status"].map((header) => (
          <TableCell
            key={header}
            sx={{
              borderRight: "1px solid #ddd",
              padding: "4px",
              textAlign: "center",
              backgroundColor: "#fff9c4",
              fontSize: "12px",
              fontWeight: "bold",
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

    {loading ? (
    <TableBody>
        <TableRow>
          <TableCell colSpan={10} sx={{ textAlign: "center", padding: "20px" }}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CircularProgress />
              <Typography variant="body2" sx={{ mt: 1 }}>
                Loading Data...
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
        </TableBody>
      ) : classfilteredData.length === 0 ? (
        <TableBody>
        <TableRow>
          <TableCell colSpan={10} sx={{ textAlign: "center", padding: "20px" }}>
            No data found
          </TableCell>
        </TableRow>
        </TableBody>
      ) : (
        <TableBody
        className="scroll-animation"
  onMouseEnter={(e) => {
    e.currentTarget.style.animationPlayState = 'paused';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.animationPlayState = 'running';
  }}
       
        >
        {classfilteredData.map((row, index) => (
          <TableRow
            key={index}
            sx={{
              backgroundColor: "white",
              transition: "background-color 0.3s",
              "&:hover": { backgroundColor: "#f5f5f5" }, // Hover effect
            }}
          >
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {index + 1}
            </TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {row.dayName}
            </TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {row.romanNumberClass || "N/A"}
            </TableCell>
            {(board === "INTERMEDIATE") &&(
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {row.course || "N/A"}
            </TableCell>
            )}
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {row.sections || "N/A"}
            </TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {row.subject}
            </TableCell>
            {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
            {`${row.firstName} ${row.lastName}`}
            </TableCell> */}
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
  {row.firstName || row.lastName
    ? `${row.firstName || ""} ${row.lastName || ""}`.trim()
    : "N/A"}
</TableCell>

            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
              {row.timeSlot}
            </TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
               Period {row.period}
            </TableCell>
            <TableCell sx={{ padding: "4px", textAlign: "center" }}>
  <Button
    variant="contained"
    sx={{
      textTransform: "none",
     backgroundColor:
  row.status === "Ongoing"
    ? "#FFA500" // Orange
    : row.status === "Absent"
    ? "#F63E40" // Red
    : row.status === "InProgress"
    ? "#EEC20E" // Yellow
    : row.status === "Completed"
    ? "#67BB45" // Green
    : row.status === "ClassNotStarted"
    ? "#B0B0B0" // Light Gray
    : row.status === "ClassStarted"
    ? "#3F51B5" // Blue
    : "#999", // Default grey for unknown status
      color: "#fff",
      fontWeight: "bold",
      borderRadius: "8px",
      padding: "2px 5px",
      fontSize: "10px",
      boxShadow: "none",
      cursor: "default",
      "&:hover": {
  backgroundColor:
    row.status === "Ongoing"
      ? "#FFA500"
      : row.status === "Absent"
      ? "#F63E40"
      : row.status === "InProgress"
      ? "#EEC20E"
      : row.status === "Completed"
      ? "#67BB45"
      : row.status === "ClassNotStarted"
      ? "#B0B0B0"
      : row.status === "ClassStarted"
      ? "#3F51B5"
      : "#999",
},
    }}
  >
    {row.status}
  </Button>
</TableCell>

          </TableRow>
        ))}
       </TableBody>
      )}
  </Table>
</TableContainer>









        </div>
        </Paper>

{/* pie chart  for SchoolFee*/}
<div
  style={{
    display: "flex",
    flex: 1.05,
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  }}
>
  <div style={{ position: "relative", width: "100%" }}>
    {/* Dropdown (Date Range) */}
    <FormControl
      variant="outlined"
      size="small"
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 1,
        width: "150px",
        height: "30px",
      }}
    >
      <InputLabel>Select Range</InputLabel>
      <Select
        value={dateRange}
        onChange={(e) => setDateRange(e.target.value)}
        label="Select Range"
        style={{ height: "30px", fontSize: "12px" }}
      >
        <MenuItem value="today">Today</MenuItem>
        <MenuItem value="yesterday">Yesterday</MenuItem>
        <MenuItem value="lastWeek">Last Week</MenuItem>
        <MenuItem value="CurrentMonth">Current Month</MenuItem>
        <MenuItem value="last6Months">Last 6 Months</MenuItem>
         <MenuItem value="currentAcademicYear">Current Academic Year</MenuItem>
      </Select>
    </FormControl>

    {/* Table Container */}
    <TableContainer
      component={Paper}
      style={{
        height: "380px",
        width: "100%",
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        paddingTop: "1px",
        boxShadow: "none",
        border: "none",
      }}
    >
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          textAlign: "left",
          paddingLeft: "15px",
          marginBottom: "10px",
          marginTop: "10px",
          color: "#333",
        }}
      >
        School Fee Payments
      </Typography>

      {/* <Table style={{ border: "none" }}>
  <TableBody>
    <TableRow>
      <TableCell style={{ padding: 0, height: "100%" ,borderBottom: "none", textAlign: "center"}}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: "5px", // Reduced left padding
            paddingBottom: "5px", // Reduced bottom padding
          }}
        >
     
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              width: "280px",
              height: "280px",
            }}
          >
           
            <ResponsiveContainer width={270} height={280}>
              <PieChart>
                <Pie
                  data={finalPieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={40}
                  outerRadius={90}
                  paddingAngle={3}
                  dataKey="value"
                  label={({ percent }) =>
                    hasData ? `${(percent * 100).toFixed(1)}%` : ""
                  }
                >
                  {finalPieData.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>

         
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              marginTop: "1px",
              paddingBottom: "5px", // Adjusted bottom spacing
            }}
          >
            {pieData.map((entry, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "3px 8px", // Reduced margin
                }}
              >
                <div
                  style={{
                    width: "10px", // Slightly reduced dot size
                    height: "10px",
                    backgroundColor: entry.color,
                    marginRight: "4px", // Reduced spacing
                  }}
                ></div>
                <Typography
                  variant="body2"
                  style={{
                    color: "#333",
                    fontWeight: "bold",
                    fontSize: "11px", // Slightly reduced font size
                  }}
                >
                  {entry.name}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </TableCell>
    </TableRow>
  </TableBody>
</Table> */}


<Table style={{ border: "none" }}>
  <TableBody>
    <TableRow>
      <TableCell
        style={{
          padding: 0,
          height: "100%",
          borderBottom: "none",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: "5px",
            paddingBottom: "5px",
          }}
        >
          {/* Chart or No Data Message */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              width: "280px",
              height: "280px",
            }}
          >
            {hasData ? (
              <ResponsiveContainer width={270} height={280}>
                <PieChart>
                  <Pie
                    data={finalPieData}
                    cx="50%"
                    cy="50%"
                    innerRadius={35}
                    outerRadius={80}
                    paddingAngle={3}
                    dataKey="value"
                   label={({ value }) => {
        const percent = total === 0 ? 0 : (value / total) * 100;
        return `${percent.toFixed(1)}%`;
      }}

                  >
                    {finalPieData.map((entry, index) => (
                      // <Cell key={index} fill={entry.color} />
                       <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <Typography
                variant="body2"
                style={{
                  color: "#888",
                  fontSize: "14px",
                  fontWeight: 900,
                }}
              >
                No data available
              </Typography>
            )}
          </div>

          {/* Bottom Labels */}
          {hasData && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginTop: "1px",
                paddingBottom: "5px",
              }}
            >
              {pieData.map((entry, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "3px 8px",
                  }}
                >
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: entry.color,
                      marginRight: "4px",
                    }}
                  ></div>
                  <Typography
                    variant="body2"
                    style={{
                      color: "#333",
                      fontWeight: "bold",
                      fontSize: "11px",
                    }}
                  >
                    {entry.name}
                  </Typography>
                </div>
              ))}
            </div>
          )}
        </div>
      </TableCell>
    </TableRow>
  </TableBody>
</Table>


    </TableContainer>
  </div>
</div>




      </div>

     
{/* Bus Student  */}

{(feature === "CORE" || feature === "ULTRA") && (


<     div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between" }}>

         {/* Card containing table title, bus selector, and table */}

      <Paper style={{ flex: 2, padding: "5px", backgroundColor: "#FFFFFF", borderRadius: "8px", marginRight: "5px" }}>

    <div style={{ flex: 2, marginLeft: "0px", paddingLeft: "10px", paddingRight: "10px", overflow: "auto" }}>
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap", // Optional: helpful for responsiveness
    marginBottom: "16px"
  }}
>
  {/* Left-aligned heading */}
  <Typography
    variant="h5"
    style={{
      fontWeight: "bold",
      paddingLeft: "5px",
      marginTop: "5px"
    }}
  >
    Bus Attendance List
  </Typography>

  {/* Right-aligned controls */}
  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <FormControl style={{ width: "150px", marginTop: "7px" }} variant="outlined" size="small">
      <InputLabel id="bus-select-label" style={{ fontSize: "12px" }}>
        Select Bus
      </InputLabel>
      {/* <Select
        labelId="bus-select-label"
        value={selectedBus}
        onChange={(e) => setSelectedBus(e.target.value)}
        label="Select Bus"
        style={{ height: "35px", fontSize: "12px" }}
      >
        {busData.map((bus, index) => (
         <MenuItem key={index} value={bus.busNumber}>
          {bus.busNumberPlate}
        </MenuItem>
        ))}
      </Select> */}
       <Select
     labelId="bus-select-label"
  value={selectedBus || ""}
  onChange={(e) => setSelectedBus(e.target.value)}
   label="Select Bus"
        style={{ height: "35px", fontSize: "12px" }}
>
  {busData.map((bus, index) => (
    <MenuItem key={index} value={String(bus.busNumber)}>
      {bus.busNumberPlate}
    </MenuItem>
  ))}
</Select>
    </FormControl>

   



   
  </div>
</div>


  <TableContainer
    component={Paper}
    style={{
      maxHeight: "200px", // Reduced height from 280px to 200px
      overflowY: "auto",
      marginTop: "10px",
      position: "relative"
    }}
    // onMouseEnter={(e) => {
    //   e.currentTarget.querySelector('tbody').style.animationPlayState = "paused"; // Pause scrolling on hover
    // }}
    // onMouseLeave={(e) => {
    //   e.currentTarget.querySelector('tbody').style.animationPlayState = "running"; // Resume scrolling on hover
    // }}
  >
 
      <Table stickyHeader>
        <thead>
          <tr>
            {["S.No", "Route No", "Bus No", "Driver Name", "Student Name", "PicUp Location", "Time", "Status"].map(
              (header) => (
                <th
                  key={header}
                  style={{
                    padding: "3px 8px",
                    border: "1px solid #ccc",
                    backgroundColor: "#fff9c4",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    fontSize: "12px",
                  }}
                >
                  {header}
                </th>
              )
            )}
          </tr>
        </thead>
        {/* style={{ animation: "scrollUp 15s linear infinite" }} */}
        <TableBody>
        {tableLoading ? (
          <TableRow>
            <TableCell colSpan={8} sx={{ textAlign: "center", padding: "20px" }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress />
                <Typography variant="body2" sx={{ mt: 1 }}>Loading Data...</Typography>
              </Box>
            </TableCell>
          </TableRow>
        ) : filteredResults.length === 0 ? (
          <TableRow>
            <TableCell colSpan={8} sx={{ textAlign: "center" }}>No data found.</TableCell>
          </TableRow>
        ) : (
          filteredResults.map((row, index) => (
            <TableRow key={row.id}
              style={{ backgroundColor: "white", transition: "background-color 0.3s", height: "40px" }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
            >
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{index + 1}</TableCell>
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.routeNumber}</TableCell>
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.busNumber}</TableCell>
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.firstName} {row.lastName}</TableCell>
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentFirstName} {row.studentLastName}</TableCell>
                            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.stopName}</TableCell>
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.inTime}</TableCell>
              <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
              <Button
                  variant="contained"
                  sx={{
                    backgroundColor: row.status === "Present" ? "#67BB45" : "#F63E40",
                    color: "#fff",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    padding: "1px 3px",
                    fontSize: "10px",
                    boxShadow: "none",
                    cursor: "default",
                    "&:hover": {
                      backgroundColor: row.status === "Present" ? "#67BB45" : "#F63E40", // Prevent darkening effect
                    },
                  }}
                >
                  {row.status}
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
      </Table>
      {/* <style>
        {`
           @keyframes scroll {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(100%); }
            }
        `}
      </style> */}
    </TableContainer>


</div>
        </Paper>


{/* pie chart for BusFee*/}
<div
  style={{
    flex: 1,
    marginLeft: "1px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  }}
>
  <div style={{ position: "relative", width: "100%" }}>
        {/* <FormControl
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          zIndex: 1,
          width: "100px",
          height: "30px",
        }}
      >
        <InputLabel id="pie-select-label" style={{ fontSize: "12px" }}>
          Select Date
        </InputLabel>
        <Select
          labelId="pie-select-label"
          value={pieChartDate}
          onChange={(e) => setPieChartDate(e.target.value)}
          label="Select Date"
          style={{ height: "35px", fontSize: "12px" }}
        >
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="yesterday">Yesterday</MenuItem>
          <MenuItem value="lastWeek">Last Week</MenuItem>
          <MenuItem value="lastMonth">Last Month</MenuItem>
          <MenuItem value="currentMonth">Current Month</MenuItem>
        </Select>
      </FormControl> */}


      <TableContainer
  style={{
    height: "250px", // Reduced height from full to 250px
    width: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    paddingTop: "20px",
    boxShadow: "none",
    border: "none",
  }}
>

      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          textAlign: "left",
          marginTop: "0px", // Added top margin for spacing
          paddingLeft: "30px", // Added left padding
          marginBottom: "10px",
          color: "#333",
        }}
      >
        BusFee Payments
      </Typography>

      <Table style={{ border: "none" }} >
        <TableBody>
          <TableRow>
            <TableCell
                    style={{
                    padding: 0,
                    height: "100%",
                    borderBottom: "none",
                    textAlign: "center",
                    }} >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Pie Chart */}
               <div
                                                   style={{
                                                     position: "relative",
                                                     display: "flex",
                                                     flexDirection: "column",
                                                     alignItems: "center",
                                                     marginTop: "-25px",
                                                     // backgroundColor: "#fff",
                                                     // padding: "5px",
                                                     // borderRadius: "8px",
                                                     // boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                                                   }}
                                                 >
                                                   {/* Pie Chart */}
                                                 <ResponsiveContainer width={210} height={210}>
  <PieChart>
    <Pie
      data={finalPieData1}
      cx="50%"
      cy="50%"
      innerRadius={23}
      outerRadius={50}
      paddingAngle={2}
      dataKey="value"
      label={({ value }) => {
        const percent = total1 === 0 ? 0 : (value / total1) * 100;
        return `${percent.toFixed(1)}%`;
      }}
     
    >
      {finalPieData1.map((entry, index) => (
        <Cell key={index} fill={entry.color} />
      ))}
    </Pie>
    <Tooltip />
  </PieChart>
</ResponsiveContainer>
                             
                                                   {/* Center Text */}
                                                   {/* <div
                                                     style={{
                                                       position: "absolute",
                                                       top: "50%",
                                                       left: "50%",
                                                       transform: "translate(-50%, -50%)",
                                                       textAlign: "center",
                                                       fontWeight: "bold",
                                                       fontSize: "14px",
                                                     }}
                                                   >
                                                     <p>95.67%</p>
                                                     <p style={{ fontSize: "12px", color: "#666" }}>
                                                       OVERALL
                                                     </p>
                                                   </div> */}
                               </div>

                {/* Labels on the right side of the pie chart */}
                <div
                                                    style={{
                                                      paddingLeft: "15px",
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      justifyContent: "center",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    {pieData1.map((entry, index) => (
                                                      <div
                                                        key={index}
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          marginBottom: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "12px",
                                                            height: "12px",
                                                            backgroundColor: entry.color,
                                                            marginRight: "8px",
                                                          }}
                                                        ></div>
                                                        <Typography
                                                          variant="body2"
                                                          style={{
                                                            color: "#333",
                                                            fontWeight: "bold",
                                                            fontSize: "11px",
                                                          }}
                                                        >
                                                          {entry.name}
                                                        </Typography>
                                                      </div>
                                                    ))}
                                                  </div>

              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </div>
        </div>


      </div>
)}

{/* Notice Board and Expenses */}

                   <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between", height: "400px" }}>    
                                                             
                                       
                                                              {/* //notice board */}
                                                          <Paper
                                                            style={{
                                                              flex: 2,
                                                              padding: "5px",
                                                              backgroundColor: "#FFFFFF",
                                                              borderRadius: "8px",
                                                              marginRight: "5px",
                                                              height: "100%",
                                                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                flex: 2,
                                                                marginLeft: "0px",
                                                                paddingLeft: "10px",
                                                                paddingRight: "10px",
                                                                overflow: "auto",
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "space-between",
                                                                  alignItems: "center",
                                                                  position: "sticky",
                                                                  top: "0",
                                                                  backgroundColor: "#FFFFFF",
                                                                  zIndex: 1,
                                                                }}
                                                              >
                                                                <Typography
                                                                  variant="h5"
                                                                  style={{
                                                                    fontWeight: "bold",
                                                                    paddingLeft: "5px",
                                                                    marginTop: "5px",
                                                                    color: "#333",
                                                                  }}
                                                                >
                                                                  Notice Board
                                                                </Typography>
                                                              </div>
                                                              <GlobalStyles
                                                                styles={{
                                                                  '.custom-sidebar-scrollbar': {
                                                                    scrollbarWidth: 'thin',
                                                                    scrollbarColor: 'grey #e0e0e0',
                                                                  },
                                                                  '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                                                    width: '6px',
                                                                  },
                                                                  '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                                                    background: '#f1f1f1',
                                                                  },
                                                                  '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                                                    backgroundColor: 'grey',
                                                                    borderRadius: '10px',
                                                                  },
                                                                  '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                                                    backgroundColor: '#555',
                                                                  },
                                                                }}
                                                              />
                                                              <div className="notice-container custom-sidebar-scrollbar" style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                                                                {loadingNotices ? (
                                                                  <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                                                                    <CircularProgress />
                                                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                                                      Loading Notices...
                                                                    </Typography>
                                                                  </Box>
                                                                ) : filteredNotices.length === 0 ? (
                                                                  <Typography
                                                                    variant="h6"
                                                                    sx={{
                                                                      textAlign: "center",
                                                                      color: "#666",
                                                                      width: "100%",
                                                                      padding: "20px",
                                                                      fontStyle: "italic",
                                                                    }}
                                                                  >
                                                                    No notices available.
                                                                  </Typography>
                                                                ) : (
                                                                  filteredNotices.map((notice, index) => (
                                                                    <Box
                                                                      key={index}
                                                                      sx={{
                                                                        padding: "15px",
                                                                        borderRadius: "10px",
                                                                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                                                        backgroundColor: "#D1E9F6",
                                                                        position: "relative",
                                                                        overflow: "hidden",
                                                                        marginBottom: "10px",
                                                                      }}
                                                                    >
                                                                      {new Date() - new Date(notice.purposeDate) < 24 * 60 * 60 * 1000 && (
                                                                        <Box
                                                                          sx={{
                                                                            position: "absolute",
                                                                            top: "0",
                                                                            right: "0",
                                                                            backgroundColor: "blue",
                                                                            color: "#fff",
                                                                            fontWeight: "bold",
                                                                            fontSize: "0.75rem",
                                                                            padding: "6px 12px",
                                                                            textTransform: "uppercase",
                                                                            borderTopRightRadius: "8px",
                                                                            borderBottomLeftRadius: "8px",
                                                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                                          }}
                                                                        >
                                                                          New!
                                                                        </Box>
                                                                      )}
                                       
                                                                      <Box
                                                                        sx={{
                                                                          backgroundColor: "#4CAF50",
                                                                          color: "white",
                                                                          width:"110px",
                                                                          padding: "5px 10px",
                                                                          borderRadius: "5px",
                                                                          fontWeight: "bold",
                                                                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                                          "&:hover": {
                                                                            transform: "scale(1.05)",
                                                                          },
                                                                        }}
                                                                      >
                                                                        {notice.purposeDate}
                                                                      </Box>
                                       
                                                                      <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginTop: "10px" }}>
                                                                        {notice.title}
                                                                      </Typography>
                                                                      <Typography variant="body2" sx={{ marginTop: "5px", color: "#333", fontWeight: "bold" }}>
                                                                        {notice.description}
                                                                      </Typography>
                                                                      <Typography variant="body2" sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}>
                                                                        Sent By: {notice.nameOfCreatedByNotice}
                                                                        {/* , Time: {notice.time} */}
                                                                      </Typography>
                                                                    </Box>
                                                                  ))
                                                                )}
                                                              </div>
                                                            </div>
                                                          </Paper>
                                       
                                       
                                       
                                                      {/* Expenses bar chart */}
                                       
                                                      <div style={{ position: "relative", width: "40%" }}>
                                          <TableContainer
                                                style={{ backgroundColor: "#FFFFFF", borderRadius: "8px", paddingTop: "20px",height: "100%", }}
                                              >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "0 0 10px 10px",
                                               
                                              }}
                                            >
                                              <Typography variant="h5" style={{ fontWeight: "bold", color: "#333" }}>
                                                Expenses
                                              </Typography>
                                       
                                             
                                                <FormControl style={{ width: "120px", paddingRight: "10px" }}>
                                                  <InputLabel id="month-select-label" style={{ fontSize: "12px" }}>
                                                    Select Month
                                                  </InputLabel>
                                                  <Select
                                                    labelId="month-select-label"
                                                    value={selectedMonth}
                                                    onChange={handleMonthChange}
                                                    style={{ height: "35px", fontSize: "12px" }}
                                                    label="Select Month"
                                                  >
                                                    {months.map((month, index) => (
                                                      <MenuItem key={index} value={month}>
                                                        {month}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                </FormControl>
                                             
                                            </div>
                                       
                                            <Table>
                                              <TableBody>
                                                <TableRow>
                                                  <TableCell style={{ padding: 0, height: "100%", textAlign: "center", borderBottom: "none" }}>
                                                    {expenseData.length > 0 ? (
                                                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <BarChart width={280} height={300} data={expenseData}>
                                                          <XAxis dataKey="name" interval={0}/>
                                                          <YAxis />
                                                          <Tooltip />
                                                          <Bar dataKey="value">
                                                            {expenseData.map((entry, index) => (
                                                              <Cell key={index} fill={entry.color} />
                                                            ))}
                                                          </Bar>
                                                        </BarChart>
                                                        <div
                                                          style={{
                                                            paddingLeft: "20px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                          }}
                                                        >
                                                          {expenseData.map((entry, index) => (
                                                            <div
                                                              key={index}
                                                              style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                marginBottom: "8px",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  width: "10px",
                                                                  height: "10px",
                                                                  backgroundColor: entry.color,
                                                                  marginRight: "5px",
                                                                }}
                                                              ></div>
                                                              <Typography
                                                                variant="body2"
                                                                style={{
                                                                  color: "#333",
                                                                  fontWeight: "bold",
                                                                  fontSize: "14px",
                                                                }}
                                                              >
                                                                {entry.name}
                                                              </Typography>
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <Typography variant="body2" style={{ color: "#999", fontSize: "14px" }}>
                                                        No expense data available
                                                      </Typography>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        </div>
                                       
                                       
                                       
                   </div>

    </div>
  );
};


export default Dashboard;